import { Button } from "@fluentui/react-components";
import { Dialog, DialogActions, DialogBody, DialogContent, DialogSurface, DialogTitle } from "@fluentui/react-dialog";
import React from "react";

type Props = {
  isOpen: boolean;
  onClose?: () => void;
};

export const ErrorDialog: React.FC<Props> = ({
  isOpen,
  onClose,
}) => {
  const handleSubmit = () => {
    window.location.href = "/";
  };

  const handleOpenChange = (_event: React.SyntheticEvent, data: { open: boolean; }) => {
    if (!data.open && onClose) {
      onClose();
    }
  };

  return (
    <Dialog open={isOpen} onOpenChange={handleOpenChange}>
      <DialogSurface>
        <DialogTitle>
          エラーが発生しました
        </DialogTitle>
        <DialogBody>
          <DialogContent>
            <p>申し訳ありませんが、予期しないエラーが発生しました。</p>
            <p>トップページに戻って、もう一度お試しください。</p>
          </DialogContent>
          <DialogActions>
            <Button appearance="primary" onClick={handleSubmit}>
              トップページに戻る
            </Button>
          </DialogActions>
        </DialogBody>
      </DialogSurface>
    </Dialog>
  );
};
